import { ConfigProvider as ConfigProvider$1 } from 'antd';
import useTheme from 'antd/es/config-provider/hooks/useTheme';
import * as React from 'react';
import { getTheme } from '../theme/themes/default/index.js';
import useStyle from './style/index.js';
import { supportsPseudoClass } from './util/index.js';

var _excluded = ["children", "theme", "isCSSWhereCompatibilityCheck", "compatibilityErrorLabel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ConfigProvider = function ConfigProvider(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    isCSSWhereCompatibilityCheck = _ref.isCSSWhereCompatibilityCheck,
    compatibilityErrorLabel = _ref.compatibilityErrorLabel,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // merge default base theme token and user theme
  // console.log('theme from parameter', theme);
  var currentTheme = useTheme(theme, getTheme());
  var wrapSSR = useStyle(currentTheme);

  //* supportsPseudoClass函数操作dom存在副作用，因此使用useEffect包裹
  React.useEffect(function () {
    //* :where伪类兼容性检测
    if (isCSSWhereCompatibilityCheck && !supportsPseudoClass(':where()'))
      // alert(compatibilityErrorLabel || 'CSS style error, please upgrade your browser!');
      // window.onload = () => {
      //   alert(compatibilityErrorLabel || 'CSS style error, please upgrade your browser!');
      // };
      setTimeout(function () {
        alert(compatibilityErrorLabel || 'CSS style error, please upgrade your browser!');
      }, 0);
  }, []);
  return /*#__PURE__*/React.createElement(ConfigProvider$1, _extends({}, props, {
    theme: currentTheme
  }), wrapSSR(children));
};
ConfigProvider.ConfigContext = ConfigProvider$1.ConfigContext;
ConfigProvider.config = ConfigProvider$1.config;
ConfigProvider.useConfig = ConfigProvider$1.useConfig;
// deprecated 等待antd升级后删除
ConfigProvider.SizeContext = ConfigProvider$1.SizeContext;

export { ConfigProvider as default };
